import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import SelectInput from '../../types/select-input';
import { StandardInputField } from '../../types/standard-input-field';
import { getMonths, getYears } from '../../util/create-objects';
import { composeValidators, configurableMinLengthValidator, requiredField } from '../../util/validator';
const PepItem = _ref => {
  let {
    index,
    handleRemove,
    countries,
    positions,
    isFromServer,
    minCommentLength
  } = _ref;
  const pepLabels = {
    description: 'Beskriv verv eller stilling',
    position: 'Hvilket høytstående verv eller stilling?',
    endDate: 'Hvis PEP- verv eller stilling er avsluttet, når ble det avsluttet? (valgfritt)',
    country: 'Land'
  };
  const countriesToShow = [{
    text: 'Velg',
    value: 'velg',
    key: '0'
  }, ...countries.map((el, i) => {
    return {
      text: el.text,
      value: el.iso3,
      key: (i + 1).toString()
    };
  })];
  const months = getMonths();
  const years = getYears(5);
  return /*#__PURE__*/React.createElement("div", {
    className: "sub-question-wrapper"
  }, !isFromServer && index !== 0 && /*#__PURE__*/React.createElement(IconButton, {
    icon: IconTypes.KRYSS_24,
    className: "sgw-button remove-icon",
    onClick: () => handleRemove && handleRemove(),
    screenReaderText: "fjern pep svar"
  }), /*#__PURE__*/React.createElement(SelectInput, {
    label: pepLabels.position,
    name: "pepValues[".concat(index, "].position"),
    validate: requiredField,
    values: positions,
    disabled: isFromServer
  }), !isFromServer && /*#__PURE__*/React.createElement(StandardInputField, {
    label: pepLabels.description,
    name: "pepValues[".concat(index, "].description"),
    validate: composeValidators(requiredField, value => configurableMinLengthValidator(value, minCommentLength))
  }), /*#__PURE__*/React.createElement(SelectInput, {
    label: pepLabels.country,
    name: "pepValues[".concat(index, "].country"),
    validate: requiredField,
    values: countriesToShow,
    disabled: isFromServer
  }), /*#__PURE__*/React.createElement("span", {
    className: "sgw-select__mainlabel extra-margin-top"
  }, pepLabels.endDate), /*#__PURE__*/React.createElement(SelectInput, {
    label: "\xC5r",
    name: "pepValues[".concat(index, "].year"),
    values: years
  }), /*#__PURE__*/React.createElement(SelectInput, {
    label: "M\xE5ned",
    name: "pepValues[".concat(index, "].month"),
    values: months
  }));
};
export default PepItem;